import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "../../environments/environment";
import { Pair } from "../obj/Pair";
import { AbstractComponent } from "./abstract/abstract.component";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { User } from "../entity/User";
import { Company } from "../entity/Company";

@Component({
    selector: "kilowant-activation",
    templateUrl: "../../html/main-activation.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class ActivationComponent extends AbstractComponent {
    activationOK: boolean = false;
    activationNOTOK: boolean = false;
    activationLinkSent: boolean = false;

    constructor(
        router: Router,
        route: ActivatedRoute,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        private renderer: Renderer2,
        dialog: MatDialog
    ) {
      super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
    }

    ngOnInit(): void {
        this.route.queryParams.forEach((params: Params) => {
            let data: string = params["data"];
            let email: string = params["email"];
            if ((data==null || data=="") && (email==null || email=="")) {
               this.router.navigate(["/user/registration"]);
            }
            if ((data!=null && data!="")) {
                this.generalService.activateUser(data)
                .subscribe((res:any) => {
                   this.router.navigate(["/user/login"]);
                },
                err => {
                   this.activationNOTOK = true;
                   this.activationOK = false;
                });
            } else if ((email!=null && email!="")) {
                this.generalService.sendActivationLink(email)
                .subscribe((res:any) => {
                   this.activationLinkSent = true;
                },
                err => {
                });
            }
        });
    }
}